/* 阶梯状 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import _ceil from 'lodash/ceil';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

const ROWS = 16;
const COLUMNS = 16;

export default class StripsFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.BottomLeft,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.BottomLeft;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.STRIPS;

    protected matrixCache: Map<string, any>;

    /**
     * NOTE: office 中将图形分割成 16 * 16 个格子元素完成阶梯状动画
     * 默认当元素宽高均大于 16 时候使用元素宽高除以 16 得到每个格子大小
     * 当小于 16 时候使用 1 像素作为宽高，行列数量就取元素宽高
     * 渲染过程可以简单理解为渲染 16 行/列，根据动画进度增加/减少单位长度/高度
     * TODO:  近四个单位的元素块做颜色透明度变化
     */
    protected rows = ROWS;
    protected cols = COLUMNS;
    protected itemWidth: number;
    protected itemHeight: number;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof StripsFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
        this.cols = COLUMNS;
        this.rows = ROWS;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        const { x, y, width } = this.initItemInfo(canvas);
        const process = this.isEntr
            ? Math.ceil(this.rate * this.cols * 2) : Math.ceil((1 - this.rate) * this.cols * 2);
        const isTop = [PresetSubtype.TopRight, PresetSubtype.TopLeft].includes(this.direction);
        const isRight = [PresetSubtype.TopRight, PresetSubtype.BottomRight].includes(this.direction);
        const ceilHeight = _ceil(this.itemHeight || 0);

        for (let i = 0; i < this.rows; i++) {
            const offset = isTop ? ((this.cols - i) * this.itemWidth) : (i * this.itemWidth) ;
            const renderY =  y + (i * this.itemHeight);
            const renderX = isRight
                ? x - offset + (process * this.itemWidth) : x - (process * this.itemWidth);
            const renderWidth = isTop
                ? width + ((this.cols - i) * this.itemWidth) : width + (i * this.itemWidth);
            canvas.clearRect(renderX, renderY, renderWidth, ceilHeight);
        }
    }

    protected initItemInfo(canvas) {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;

        this.rows = height > this.rows ? this.rows : height;
        this.cols = width > this.cols ? this.cols : width;
        this.itemWidth = width / this.cols;
        this.itemHeight = height / this.rows;

        return { width, height, x, y };
    }

    protected get isEntr() {
        return this.action === Action.ENTR;
    }
}
